<template>
  <div class="users">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Monitor</span>
      </heading-wrap>
      <spinner v-if="loading" />
      <div class="row">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Bots Health</h4>
            <slot-table :columns="table.renderHealth.columns" :data="renderHealth.summary">
              <template slot="status" slot-scope="props">
                  <span :class="getStatusClass(props.item.status)">
<!--                    {{ props.item.status }}-->
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
              </template>
            </slot-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Render Bots</h4>
            <slot-table :columns="table.renderBots.columns" :data="renderHealth.bots">
              <template slot="client" slot-scope="props">
                <span>
                  <router-link :to="{ path: `/client/${props.item.client.hash_id}` }">
                    {{ props.item.client.name }}
                  </router-link>
                </span>
              </template>
              <template slot="status" slot-scope="props">
                  <span :class="getStatusClass(props.item.status)">
<!--                    {{ props.item.status }}-->
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
              </template>
              <template slot="actions" slot-scope="props">
                <button-cta
                    title="confirm"
                    data-modalType="deleteRenderBot"
                    :data-modalID="props.item.id"
                    :data-modalField="props.item.action"
                    class="btn btn-danger btn-xs"
                    :onClick="onLaunchModal"
                    @click="deleteRenderBot(props.item.id)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
              </template>

            </slot-table>
          </div>
        </div>
      </div>
    </div>
    <portal to="globalModal">
      <modal-render-bot-delete-confirm :show="showModal.deleteRenderBot" :type="modalType" :field="modalField" :confirmId="modalId" @close="toggleModal('deleteRenderBot')"/>
    </portal>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import ButtonCta from '@/components/Button/button'
import { modalMixin } from '@/mixins/modalMixin'
import { monitorMixin } from '@/mixins/monitorMixin'
import ModalRenderBotDeleteConfirm from '@/components/Modal/render-bot/modal-render-bot-delete-confirm'

export default {
  name: 'Monitor',
  mixins: [ monitorMixin, modalMixin ],
  components: {
    HeadingWrap,
    SlotTable,
    ButtonCta,
    Spinner,
    ModalRenderBotDeleteConfirm
  },
  data: () => ({
    table: {
      renderHealth: {
        columns: {
          type: 'Type',
          total_count: 'Total Count',
          active_count: 'Active Count',
          healthy_count: 'Healthy Count',
          // turning_count: 'Turning Count',
          unhealthy_count: 'Unhealthy Count',
          disabled_count: 'Disabled Count',
          percentage: 'Percentage',
          status: 'Status'
        }
      },
      renderBots: {
        columns: {
          name: 'Name',
          hostname: 'Hostname',
          creative_type: 'Creative Type',
          client: 'Client',
          last_action_text: 'Last Action Text',
          last_auth_text: 'Last Auth Text',
          status: 'Status',
          actions: 'Actions'
        }
      }
    },
    timeoutId: null
  }),
  methods: {
    updateRenderHealth (loading = true) {
      if (loading) this.startLoading()
      this.getRenderHealth().then(() => {
        if (loading) this.finishLoading()
        this.timeoutId = setTimeout(() => this.updateRenderHealth(false), 60000)
      })
    },
    // updateRenderBots (loading = true) {
    //   if (loading) this.startLoading()
    //   this.getRenderBots().then(() => {
    //     if (loading) this.finishLoading()
    //     this.timeoutId = setTimeout(() => this.updateRenderBots(false), 60000)
    //   })
    // },
    cancelTimeout () {
      clearTimeout(this.timeoutId)
    },
    getStatusClass (status) {
      let className = 'label label-pill label-'
      switch (status) {
        case 'green':
          return `${className}success`
        case 'yellow':
          return `${className}warning`
        case 'red':
          return `${className}danger`
        case 'black':
          return `${className}black`
      }
    }
  },
  mounted () {
    this.updateRenderHealth(false)
    // this.updateRenderBots()
  },
  beforeDestroy () {
    this.cancelTimeout()
  }
}
</script>

<style lang="scss">
.monitor_summary {
  display: flex;
  padding: 5px;
  margin: 5px
}
.monitor_summary_item {
  margin: 5px;
}
.label-black {
  background-color: #0f0f0f;
}
</style>



// WEBPACK FOOTER //
// src/pages/monitor/index.vue